import { z } from 'zod';
import type { BlockDefinition } from '../types';

export const imageSchema = z.object({
  src: z.string().min(1).max(500),
  alt: z.string().max(200).default(''),
  caption: z.string().max(300).optional(),
  width: z.enum(['narrow', 'wide', 'full']).default('wide'),
  align: z.enum(['left', 'center', 'right']).default('center'),
});

export type ImageData = z.infer<typeof imageSchema>;

export function ImageRenderer({ src, alt, caption, width, align }: ImageData) {
  return (
    <figure className={`v5-image v5-image--${width} v5-image--align-${align}`}>
      <img src={src} alt={alt} loading="lazy" />
      {caption ? <figcaption className="v5-image-caption">{caption}</figcaption> : null}
    </figure>
  );
}

export const imageBlock: BlockDefinition<ImageData> = {
  meta: {
    type: 'image',
    label: 'Imagen',
    description: 'Imagen contenida con caption opcional.',
    category: 'media',
    icon: 'image',
  },
  schema: imageSchema,
  defaults: {
    src: '/assets/image-placeholder.jpg',
    alt: '',
    width: 'wide',
    align: 'center',
  },
  fields: [
    { name: 'src', label: 'Imagen', type: 'image', required: true },
    { name: 'alt', label: 'Texto alternativo', type: 'text', max: 200 },
    { name: 'caption', label: 'Caption', type: 'text', max: 300 },
    {
      name: 'width',
      label: 'Ancho',
      type: 'select',
      options: [
        { label: 'Estrecha', value: 'narrow' },
        { label: 'Ancha', value: 'wide' },
        { label: 'Completa', value: 'full' },
      ],
    },
    {
      name: 'align',
      label: 'Alineación',
      type: 'select',
      options: [
        { label: 'Izquierda', value: 'left' },
        { label: 'Centro', value: 'center' },
        { label: 'Derecha', value: 'right' },
      ],
    },
  ],
  Renderer: ImageRenderer,
};
